export default __webpack_public_path__ + "static/media/chosen-icon.978531a5.svg";